import { Divider } from "@mui/material";
import HeaderWithFilter from "components/headerwithfilter";
import LoadingEmptyError from "components/LoaderEmptyErrorState";
import keys from "locale/keys";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import Coin from "../../../assets/icons/coin.svg";
import { getSurveyProfilerApi } from "../../../data/slices/surveyprofiler/api";
import { DASHBOARD_ROUTES, STORAGE_USER_ID } from "../../../utils/constants";
import { surveyProfilerCategoryMapper } from "../../../utils/mappers/SurveyProfilerMapper";
import { getFromLocalStorage } from "../../../utils/Utils";
import Rewards from "../../../widgets/dashboard/surveyprofile/Rewards";
import {
  SortTabItem,
  SurveySortTab,
} from "../../../widgets/dashboard/surveys/interface";
import SortTabs from "../../../widgets/dashboard/surveys/SortTabs";
import {
  CategoryText,
  CoinIcon,
  RewardContainer,
  RewardsContainer,
  RewardsTextContainer,
  RewardText,
  SurveyProfileMainContainer,
} from "../styled.components";
import { Wrapper } from "../styled.components";

const SurveyProfileContainer = () => {
  const [categories, setCategories] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const sortTabs: SortTabItem[] = [
    { label: t(keys.sort_best_match) },
    { label: t(keys.sort_short_surveys) },
    { label: t(keys.sort_most_points) },
    { label: t(keys.sort_max_points_per_min) },
    { label: t(keys.survey_profile) },
  ];

  const onSortTabChanged = (index: number) => {
    if (index === SurveySortTab.SURVEY_PROFILER) {
      return;
    }
    navigate(`/dashboard/${DASHBOARD_ROUTES.TASKS}`, {
      state: { selectedSortTab: index },
    });
  };

  const fetchCategories = async () => {
    const userId = getFromLocalStorage(STORAGE_USER_ID);

    try {
      setIsLoading(true);
      const response = await getSurveyProfilerApi({ userId: userId });
      // Use the mapper to transform the API response
      const mappedCategories = surveyProfilerCategoryMapper(response?.data);
      setCategories(mappedCategories);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <SurveyProfileMainContainer>
      <HeaderWithFilter title={t(keys.survey_profile)} showFilter={false} />
      <Divider />
      <Wrapper>
        <SortTabs
          tabs={sortTabs}
          selectedTab={SurveySortTab.SURVEY_PROFILER}
          onTabChanged={onSortTabChanged}
        />
      </Wrapper>
      <RewardsTextContainer>
        <CategoryText>{t(keys.survey_profile_message)}</CategoryText>
        <RewardContainer>
          <CoinIcon src={Coin} />
          <RewardText
            dangerouslySetInnerHTML={{ __html: t(keys.get_two_coins) }}
          />
        </RewardContainer>
      </RewardsTextContainer>
      <Wrapper>
        {isLoading ? (
          <LoadingEmptyError isLoading={isLoading} largesize={true} />
        ) : (
          <RewardsContainer>
            {categories.map((category, index) => (
              <Rewards category={category} key={index} />
            ))}
          </RewardsContainer>
        )}
      </Wrapper>
    </SurveyProfileMainContainer>
  );
};

export default SurveyProfileContainer;
